(() => {

  if (customElements.get('product-form')) return;

  class PFController extends HTMLElement {
    constructor() {
      super();

      this.$form = this.querySelector('form');
      this.$submit = this.querySelector('button[type="submit"]');
      this.$cartUI =
        document.querySelector('#CartDrawer') ||
        document.querySelector('#CartNotification');

      const idInput = this.$form?.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      this._bindEvents();
    }

    _bindEvents() {
      this.$form?.addEventListener('submit', (e) =>
        this._processSubmit(e)
      );
    }

    async _processSubmit(e) {
      e.preventDefault();

      if (this.$submit?.getAttribute('aria-disabled') === 'true') return;

      this._toggleError();
      this._lockButton(true);

      try {
        const requestConfig = this._buildRequest();

        // ADD TO CART
        await fetch(`${routes.cart_add_url}.js`, requestConfig);

        // FETCH FULL CART HTML
        const res = await fetch(`${routes.cart_url}`);
        const html = await res.text();

        // UPDATE UI (FULL REPLACEMENT)
        this._handleHTMLResponse(html);

      } catch (err) {
        console.error('Cart error:', err);
      } finally {
        this._cleanup();
      }
    }

    _buildRequest() {
      const cfg = fetchConfig('javascript');

      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete cfg.headers['Content-Type'];

      cfg.body = new FormData(this.$form);

      return cfg;
    }

    _handleHTMLResponse(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // REPLACE FULL DRAWER BODY
      const newBody = doc.querySelector('.th-cartDrawer_body');
      const currentBody = document.querySelector('.th-cartDrawer_body');

      if (newBody && currentBody) {
        currentBody.innerHTML = newBody.innerHTML;
      }

      // SUBTOTAL (fallback safety)
      const newSubtotal = doc.querySelector('.price-subtotal');
      const currentSubtotal = document.querySelector('.price-subtotal');

      if (newSubtotal && currentSubtotal) {
        currentSubtotal.innerHTML = newSubtotal.innerHTML;
      }

      // CART BUBBLE
      const newBubble = doc.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }

      // OPEN DRAWER
      if (this.$cartUI) {
        const bsCart =
          bootstrap.Offcanvas.getOrCreateInstance(this.$cartUI);
        bsCart.show();
      }
    }

    _lockButton(state) {
      if (!this.$submit) return;

      this.$submit.classList.toggle('loading', state);
      this.$submit.setAttribute('aria-disabled', state);

      Spinner.show();
    }

    _cleanup() {
      this.$submit?.classList.remove('loading');
      this.$submit?.removeAttribute('aria-disabled');

      Spinner.hide();
    }

    _toggleError(msg = '') {
      if (!this._errorBox) {
        this._errorBox = this.querySelector('.bs-alert');
        this._errorText =
          this._errorBox?.querySelector('.bs-error-text');
      }

      if (!this._errorBox) return;

      if (msg) {
        this._errorText.textContent = msg;
        this._errorBox.classList.remove('d-none');
      } else {
        this._errorBox.classList.add('d-none');
      }
    }
  }

  customElements.define('product-form', PFController);
})();